// TODO: (MVP-1132): these types should be generated automatically based on the API's Swagger documentation

import { UnitEnum } from './units';

// TODO: MVP-3284 check with BE if deprecated and remove
export enum FactType {
  area = 'area',
  temperature = 'temperature',
  temperature_timeseries = 'temperature_timeseries',
  precipitation = 'precipitation',
  average_slope = 'average_slope',
  prevailing_climate = 'prevailing_climate',
  prevailing_landtype = 'prevailing_landtype',
  average_soil_ph = 'average_soil_ph',
  soil_drainage = 'soil_drainage',
  soil_organic_carbon = 'soil_organic_carbon',
  soil_organic_matter = 'soil_organic_matter',
  soil_texture = 'soil_texture',
  stored_carbon = 'stored_carbon',
  total_exported_biomass = 'total_exported_biomass',
  clay = 'clay',
  sand = 'sand',
  silt = 'silt',
  erosion = 'erosion',
  humus_built = 'humus_built',
  humus_stored = 'humus_stored',
  soil_eroded = 'soil_eroded',
  soil_net_change = 'soil_net_change',
  country_name = 'country_name',
  country_iso2 = 'country_iso2',
  country_iso3 = 'country_iso3',
  fc = 'fc',
  awc = 'awc',
  pwp = 'pwp',
  fc_area = 'fc_area',
  awc_area = 'awc_area',
  pwp_area = 'pwp_area',
  soil_moisture_decade = 'soil_moisture_decade',
  average_soil_moisture = 'average_soil_moisture',
  below_wilting_point = 'below_wilting_point',
  water_storing_capacity = 'water_storing_capacity',
  water_net_change = 'water_net_change',
  grassland_type = 'grassland_type',
  grassland_converted_to_permanent_in_last_20y = 'grassland_converted_to_permanent_in_last_20y',
  grassland_num_of_mechanical_events_per_year = 'grassland_num_of_mechanical_events_per_year',
  grassland_organic_fertilizer_type = 'grassland_organic_fertilizer_type',
  carbon_captured = 'carbon_captured',
  carbon_change = 'carbon_change',
  co2_emitted = 'co2_emitted',
  permanent_soil_carbon = 'permanent_soil_carbon',
  carbon_net_change = 'carbon_net_change',
  biodiversity_trend = 'biodiversity_trend',
  biodiversity_tbd = 'biodiversity_tbd',
  habitat_score = 'habitat_score',
  biodiversity_net_change = 'biodiversity_net_change',
}
export type IndicatorFactType = R1FactType | CLIMATE_RISK_FACT_TYPES | DOMAIN_FACT_TYPES | string | MAP_LAYER_FACTS;

export enum R1FactType {
  // HACK - with custom widgets, facts that dont have a fact type defined in BE can be passed
  // use "unknown" as a placeholder type for them.
  unknown = 'unknown',
  combined_uplift_pct_change = 'combined_uplift_pct_change',

  // --------------------------------------- MAP-LAYERS
  // cckp
  annual_surface_air_temperature = 'annual_surface_air_temperature',
  annual_precipitation = 'annual_precipitation',

  // soil grids
  ocs_0_30cm_mean = 'ocs_0_30cm_mean',
  sand_0_5cm_mean = 'sand_0_5cm_mean',
  cec_0_5cm_mean = 'cec_0_5cm_mean',
  nitrogen_0_5cm_mean = 'nitrogen_0_5cm_mean',

  // landscape
  gbif_species_occurrence = 'gbif_species_occurrence',

  // --------------------------------------- MONETARY-RISK
  // current
  ecosystem_integrity_index = 'ecosystem_integrity_index',
  ecological_integrity_score = 'ecological_integrity_score',

  stewarded_value = 'stewarded_value',

  // misc
  ecosystem_integrity_index_benchmark = 'ecosystem_integrity_index_benchmark',

  // --------------------------------------- SOIL
  soil_health_historic_per_ha_graph = 'soil_health_historic_per_ha_graph',

  // --------------------------------------- SOCIAL
  // current
  social_life_expectancy = 'social_life_expectancy',

  // misc
  social_life_expectancy_max = 'social_life_expectancy_max',
  social_life_expectancy_min = 'social_life_expectancy_min',

  // historic
  social_health_historic_graph = 'social_health_historic_graph',
  social_life_expectancy_previous_5y_pct_change = 'social_life_expectancy_previous_5y_pct_change',
  social_life_expectancy_previous_1y_pct_change = 'social_life_expectancy_previous_1y_pct_change',
  social_life_expectancy_previous_5y_avg_uplift = 'social_life_expectancy_previous_5y_avg_uplift',
  social_life_expectancy_previous_1y_uplift = 'social_life_expectancy_previous_1y_uplift',

  // --------------------------------------- PROTECTED ON-FARM HABITAT

  // misc
  biodiversity_buffer_zone_pct_benchmark_graph = 'biodiversity_buffer_zone_pct_benchmark_graph',
  biodiversity_health_historic_per_ha_graph = 'biodiversity_health_historic_per_ha_graph',

  // historic
  r1_biodiversity_zone_percent_historic_graph = 'r1_biodiversity_zone_percent_historic_graph',

  r1_biodiversity_buffer_zone_pct_previous_1y_uplift_pct_change = 'r1_biodiversity_buffer_zone_pct_previous_1y_uplift_pct_change',
  r1_biodiversity_buffer_zone_pct_previous_1y_uplift_change = 'r1_biodiversity_buffer_zone_pct_previous_1y_uplift_change',
  r1_biodiversity_buffer_zone_pct_previous_5y_uplift_change = 'r1_biodiversity_buffer_zone_pct_previous_5y_uplift_change',
  biodiversity_buffer_zone_pct_previous_5y_uplift = 'biodiversity_buffer_zone_pct_previous_5y_uplift',
  biodiversity_buffer_zone_pct_previous_5y_pct_change = 'biodiversity_buffer_zone_pct_previous_5y_pct_change',
  biodiversity_buffer_zone_pct_previous_1y_pct_change = 'biodiversity_buffer_zone_pct_previous_1y_pct_change',

  biodiversity_buffer_zone_pct_min = 'biodiversity_buffer_zone_pct_min',
  biodiversity_buffer_zone_pct_max = 'biodiversity_buffer_zone_pct_max',

  // current
  r1_biodiversity_zone_percent = 'r1_biodiversity_zone_percent',
  r1_biodiversity_latest_analysis = 'r1_biodiversity_latest_analysis',
  biodiversity_buffer_zone_pct = 'biodiversity_buffer_zone_pct',

  // --------------------------------------- DEFORESTATION

  // current
  r1_deforestation_occurred_since_2020 = 'r1_deforestation_occurred_since_2020',
  deforestation_occurred_since_2020 = 'deforestation_occurred_since_2020',

  deforestation_total = 'deforestation_total',

  // historic
  deforestation_previous_5y_uplift = 'deforestation_previous_5y_uplift',
  deforestation_previous_5y_pct_change = 'deforestation_previous_5y_pct_change',
  deforestation_previous_1y_pct_change = 'deforestation_previous_1y_pct_change',

  deforestation_min = 'deforestation_min',
  deforestation_max = 'deforestation_max',

  deforestation_total_historic_graph = 'deforestation_total_historic_graph',
  deforestation_total_previous_1y_uplift = 'deforestation_total_previous_1y_uplift',

  // misc
  deforestation_total_benchmark_graph = 'deforestation_total_benchmark_graph',

  // --------------------------------------- CARBON (BGC + AGC)

  // current
  carbon_combined_per_ha = 'carbon_combined_per_ha',

  // historic
  carbon_combined_previous_5y_avg_uplift = 'carbon_combined_previous_5y_avg_uplift',
  carbon_combined_previous_5y_pct_change = 'carbon_combined_previous_5y_pct_change',
  carbon_combined_previous_1y_uplift = 'carbon_combined_previous_1y_uplift',
  carbon_combined_previous_1y_pct_change = 'carbon_combined_previous_1y_pct_change',
  carbon_combined_max = 'carbon_combined_max',

  // --------------------------------------- BELOW GROUND CARBON

  // misc
  permanent_soil_carbon_total_benchmark = 'permanent_soil_carbon_total_benchmark',
  permanent_soil_carbon_per_ha_benchmark = 'permanent_soil_carbon_per_ha_benchmark',

  carbon_health_historic_per_ha_graph = 'carbon_health_historic_per_ha_graph',

  r1_carbon_storage_bg_co2_equivalent_total = 'r1_carbon_storage_bg_co2_equivalent_total',
  r1_carbon_storage_bg_co2_equivalent_per_ha = 'r1_carbon_storage_bg_co2_equivalent_per_ha',

  // historic
  r1_soil_carbon_historic_total_graph = 'r1_soil_carbon_historic_total_graph',
  r1_soil_carbon_historic_per_ha_graph = 'r1_soil_carbon_historic_per_ha_graph',

  r1_carbon_bg_previous_1y_uplift_total = 'r1_carbon_bg_previous_1y_uplift_total',
  r1_carbon_bg_previous_1y_uplift_per_ha = 'r1_carbon_bg_previous_1y_uplift_per_ha',

  r1_carbon_bg_previous_1y_uplift_total_pct_change = 'r1_carbon_bg_previous_1y_uplift_total_pct_change',
  r1_carbon_bg_previous_1y_uplift_per_ha_pct_change = 'r1_carbon_bg_previous_1y_uplift_per_ha_pct_change',

  permanent_soil_carbon_previous_1y_uplift_per_ha_pct_change = 'permanent_soil_carbon_previous_1y_uplift_per_ha_pct_change',
  permanent_soil_carbon_total_previous_5y_avg_uplift = 'permanent_soil_carbon_total_previous_5y_avg_uplift',
  permanent_soil_carbon_per_ha_previous_5y_avg_uplift = 'permanent_soil_carbon_per_ha_previous_5y_avg_uplift',
  permanent_soil_carbon_per_ha_previous_5y_uplift = 'permanent_soil_carbon_per_ha_previous_5y_uplift',

  permanent_soil_carbon_per_ha_min = 'permanent_soil_carbon_per_ha_min',
  permanent_soil_carbon_per_ha_max = 'permanent_soil_carbon_per_ha_max',

  // current
  permanent_soil_carbon_total = 'permanent_soil_carbon_total',
  r1_carbon_storage_bg_total = 'r1_carbon_storage_bg_total',
  r1_carbon_storage_bg_per_ha = 'r1_carbon_storage_bg_per_ha',

  r1_carbon_bg_latest_analysis_total = 'r1_carbon_bg_latest_analysis_total',
  r1_carbon_bg_latest_analysis_per_ha = 'r1_carbon_bg_latest_analysis_per_ha',

  // projection
  r1_carbon_bg_uplift_potential_graph = 'r1_carbon_bg_uplift_potential_graph',
  r1_carbon_bg_uplift_potential_per_ha_graph = 'r1_carbon_bg_uplift_potential_per_ha_graph',

  r1_carbon_bg_1year_uplift_potential_total_change = 'r1_carbon_bg_1year_uplift_potential_total_change',
  r1_carbon_bg_1year_uplift_potential_per_ha_change = 'r1_carbon_bg_1year_uplift_potential_per_ha_change',

  r1_carbon_bg_1year_uplift_potential_total_pct_change = 'r1_carbon_bg_1year_uplift_potential_total_pct_change',
  r1_carbon_bg_1year_uplift_potential_per_ha_pct_change = 'r1_carbon_bg_1year_uplift_potential_per_ha_pct_change',

  permanent_soil_carbon_5y_uplift_potential_total_change = 'permanent_soil_carbon_5y_uplift_potential_total_change',
  permanent_soil_carbon_5y_uplift_potential_per_ha_change = 'permanent_soil_carbon_5y_uplift_potential_per_ha_change',

  permanent_soil_carbon_5y_uplift_potential_total_pct_change = 'permanent_soil_carbon_5y_uplift_potential_total_pct_change',
  permanent_soil_carbon_5y_uplift_potential_per_ha_pct_change = 'permanent_soil_carbon_5y_uplift_potential_per_ha_pct_change',

  permanent_soil_carbon_per_ha_previous_5y_pct_change = 'permanent_soil_carbon_per_ha_previous_5y_pct_change',
  permanent_soil_carbon_per_ha_previous_1y_pct_change = 'permanent_soil_carbon_per_ha_previous_1y_pct_change',

  permanent_soil_carbon_total_5y_avg_uplift = 'permanent_soil_carbon_total_5y_avg_uplift',
  permanent_soil_carbon_per_ha_5y_avg_uplift = 'permanent_soil_carbon_per_ha_5y_avg_uplift',

  r1_carbon_bg_10year_uplift_potential_total_change = 'r1_carbon_bg_10year_uplift_potential_total_change',
  r1_carbon_bg_10year_uplift_potential_per_ha_change = 'r1_carbon_bg_10year_uplift_potential_per_ha_change',

  r1_carbon_bg_10year_uplift_potential_total_pct_change = 'r1_carbon_bg_10year_uplift_potential_total_pct_change',
  r1_carbon_bg_10year_uplift_potential_per_ha_pct_change = 'r1_carbon_bg_10year_uplift_potential_per_ha_pct_change',

  permanent_soil_carbon_total_10y_avg_uplift = 'permanent_soil_carbon_total_10y_avg_uplift',
  permanent_soil_carbon_per_ha_10y_avg_uplift = 'permanent_soil_carbon_per_ha_10y_avg_uplift',

  permanent_soil_carbon_20y_uplift_potential_total_change = 'permanent_soil_carbon_20y_uplift_potential_total_change',
  permanent_soil_carbon_20y_uplift_potential_per_ha_change = 'permanent_soil_carbon_20y_uplift_potential_per_ha_change',

  permanent_soil_carbon_20y_uplift_potential_total_pct_change = 'permanent_soil_carbon_20y_uplift_potential_total_pct_change',
  permanent_soil_carbon_20y_uplift_potential_per_ha_pct_change = 'permanent_soil_carbon_20y_uplift_potential_per_ha_pct_change',

  permanent_soil_carbon_total_20y_avg_uplift = 'permanent_soil_carbon_total_20y_avg_uplift',
  permanent_soil_carbon_per_ha_20y_avg_uplift = 'permanent_soil_carbon_per_ha_20y_avg_uplift',

  // --------------------------------------- ABOVE GROUND CARBON (CECIL)
  // Historic cecil
  above_ground_carbon_historic_total_graph = 'above_ground_carbon_historic_total_graph',
  above_ground_carbon_historic_per_ha_graph = 'above_ground_carbon_historic_per_ha_graph',

  above_ground_carbon_per_ha_previous_5y_avg_uplift = 'above_ground_carbon_per_ha_previous_5y_avg_uplift ',

  above_ground_carbon_total_previous_1y_uplift = 'above_ground_carbon_total_previous_1y_uplift',
  above_ground_carbon_per_ha_previous_1y_uplift = 'above_ground_carbon_per_ha_previous_1y_uplift',

  above_ground_carbon_per_ha_previous_5y_pct_change = 'above_ground_carbon_per_ha_previous_5y_pct_change',
  above_ground_carbon_per_ha_previous_1y_pct_change = 'above_ground_carbon_per_ha_previous_1y_pct_change',
  above_ground_carbon_total_previous_1y_pct_change = 'above_ground_carbon_total_previous_1y_pct_change',

  // Current cecil
  above_ground_carbon_per_ha = 'above_ground_carbon_per_ha',
  above_ground_carbon_total = 'above_ground_carbon_total',

  // Misc cecil
  above_ground_carbon_total_benchmark = 'above_ground_carbon_total_benchmark',
  above_ground_carbon_per_ha_benchmark = 'above_ground_carbon_per_ha_benchmark',

  above_ground_carbon_total_benchmark_graph = 'above_ground_carbon_total_benchmark_graph',
  above_ground_carbon_per_ha_benchmark_graph = 'above_ground_carbon_per_ha_benchmark_graph',

  above_ground_carbon_per_ha_max = 'above_ground_carbon_per_ha_max',
  above_ground_carbon_per_ha_min = 'above_ground_carbon_per_ha_min',

  // --------------------------------------- ABOVE GROUND CARBON (ESA Biomass)
  // Historic
  esa_above_ground_carbon_historic_total_graph = 'esa_above_ground_carbon_historic_total_graph',
  esa_above_ground_carbon_historic_per_ha_graph = 'esa_above_ground_carbon_historic_per_ha_graph',

  esa_above_ground_carbon_total_previous_5y_pct_change = 'esa_above_ground_carbon_total_previous_5y_pct_change',
  esa_above_ground_carbon_total_previous_5y_avg_uplift = 'esa_above_ground_carbon_total_previous_5y_avg_uplift',
  esa_above_ground_carbon_per_ha_previous_5y_avg_uplift = 'esa_above_ground_carbon_per_ha_previous_5y_avg_uplift',

  esa_above_ground_carbon_total_previous_1y_uplift = 'esa_above_ground_carbon_total_previous_1y_uplift',
  esa_above_ground_carbon_per_ha_previous_1y_uplift = 'esa_above_ground_carbon_per_ha_previous_1y_uplift',

  esa_above_ground_carbon_per_ha_previous_5y_pct_change = 'esa_above_ground_carbon_per_ha_previous_5y_pct_change',
  esa_above_ground_carbon_total_previous_1y_pct_change = 'esa_above_ground_carbon_total_previous_1y_pct_change',
  esa_above_ground_carbon_per_ha_previous_1y_pct_change = 'esa_above_ground_carbon_per_ha_previous_1y_pct_change',

  // Current
  esa_above_ground_carbon_per_ha = 'esa_above_ground_carbon_per_ha',
  esa_above_ground_carbon_total = 'esa_above_ground_carbon_total',

  // Misc
  esa_above_ground_carbon_total_benchmark_graph = 'esa_above_ground_carbon_total_benchmark_graph',
  esa_above_ground_carbon_per_ha_benchmark_graph = 'esa_above_ground_carbon_per_ha_benchmark_graph',

  // --------------------------------------- WATER

  // misc
  water_fc_total_benchmark_graph = 'water_fc_total_benchmark_graph',
  water_fc_per_ha_benchmark_graph = 'water_fc_per_ha_benchmark_graph',
  water_fc_per_ha_benchmark = 'water_fc_per_ha_benchmark',
  water_fc_total_benchmark = 'water_fc_total_benchmark',

  water_health_historic_per_ha_graph = 'water_health_historic_per_ha_graph',

  soil_moisture_smooth_timeseries_per_ha_max = 'soil_moisture_smooth_timeseries_per_ha_max',

  // historic
  r1_historic_water_and_soil_moisture_graph = 'r1_historic_water_and_soil_moisture_graph',
  r1_historic_water_and_soil_moisture_per_ha_graph = 'r1_historic_water_and_soil_moisture_per_ha_graph',

  soil_moisture_smooth_timeseries_per_ha_previous_1y_pct_change = 'soil_moisture_smooth_timeseries_per_ha_previous_1y_pct_change',

  r1_whc_previous_1y_uplift_total = 'r1_whc_previous_1y_uplift_total',
  r1_whc_previous_1y_uplift_per_ha = 'r1_whc_previous_1y_uplift_per_ha',

  water_fc_per_ha_previous_5y_uplift = 'water_fc_per_ha_previous_5y_uplift',
  water_fc_per_ha_previous_5y_pct_change = 'water_fc_per_ha_previous_5y_pct_change',

  water_fc_per_ha_previous_1y_pct_change = 'water_fc_per_ha_previous_1y_pct_change',

  r1_water_whc_increase_previous_1y_uplift_total_pct_change = 'r1_water_whc_increase_previous_1y_uplift_total_pct_change',
  r1_water_whc_increase_previous_1y_uplift_per_ha_pct_change = 'r1_water_whc_increase_previous_1y_uplift_per_ha_pct_change',

  water_fc_total_previous_5y_avg_uplift = 'water_fc_total_previous_5y_avg_uplift',
  water_fc_per_ha_previous_5y_avg_uplift = 'water_fc_per_ha_previous_5y_avg_uplift',

  water_fc_per_ha_min = 'water_fc_per_ha_min',
  water_fc_per_ha_max = 'water_fc_per_ha_max',

  // current
  water_fc_total = 'water_fc_total',
  r1_water_holding_capacity_total = 'r1_water_holding_capacity_total',
  r1_water_holding_capacity_per_ha = 'r1_water_holding_capacity_per_ha',

  r1_water_holding_capacity_latest_analysis_total = 'r1_water_holding_capacity_latest_analysis_total',
  r1_water_holding_capacity_latest_analysis_per_ha = 'r1_water_holding_capacity_latest_analysis_per_ha',

  soil_moisture_smooth_timeseries_total = 'soil_moisture_smooth_timeseries_total',
  r1_soil_moisture_latest_analysis_total = 'r1_soil_moisture_latest_analysis_total',
  r1_soil_moisture_latest_analysis_per_ha = 'r1_soil_moisture_latest_analysis_per_ha',

  r1_precipitation_trend_change = 'r1_precipitation_trend_change',
  r1_soil_moisture_trend_change = 'r1_soil_moisture_trend_change',

  soil_moisture_smooth_timeseries_per_ha = 'soil_moisture_smooth_timeseries_per_ha',

  // projection
  r1_water_whc_increase_1y_uplift_potential_total_change = 'r1_water_whc_increase_1y_uplift_potential_total_change',
  r1_water_whc_increase_1y_uplift_potential_per_ha_change = 'r1_water_whc_increase_1y_uplift_potential_per_ha_change',

  r1_water_whc_increase_1y_uplift_potential_total_pct_change = 'r1_water_whc_increase_1y_uplift_potential_total_pct_change',
  r1_water_whc_increase_1y_uplift_potential_per_ha_pct_change = 'r1_water_whc_increase_1y_uplift_potential_per_ha_pct_change',

  water_fc_increase_5y_uplift_potential_total_change = 'water_fc_increase_5y_uplift_potential_total_change',
  water_fc_increase_5y_uplift_potential_per_ha_change = 'water_fc_increase_5y_uplift_potential_per_ha_change',

  water_fc_increase_5y_uplift_potential_total_pct_change = 'water_fc_increase_5y_uplift_potential_total_pct_change',
  water_fc_increase_5y_uplift_potential_per_ha_pct_change = 'water_fc_increase_5y_uplift_potential_per_ha_pct_change',

  water_fc_total_5y_avg_uplift = 'water_fc_total_5y_avg_uplift',
  water_fc_per_ha_5y_avg_uplift = 'water_fc_per_ha_5y_avg_uplift',

  r1_below_wilting_point_10year_uplift_potential_graph = 'r1_below_wilting_point_10year_uplift_potential_graph',
  r1_below_wilting_point_10year_uplift_potential_per_ha_graph = 'r1_below_wilting_point_10year_uplift_potential_per_ha_graph',

  r1_water_holding_capacity_10year_uplift_potential_graph = 'r1_water_holding_capacity_10year_uplift_potential_graph',
  r1_water_holding_capacity_10year_uplift_potential_per_ha_graph = 'r1_water_holding_capacity_10year_uplift_potential_per_ha_graph',

  r1_water_whc_increase_10y_uplift_potential_total_change = 'r1_water_whc_increase_10y_uplift_potential_total_change',
  r1_water_whc_increase_10y_uplift_potential_per_ha_change = 'r1_water_whc_increase_10y_uplift_potential_per_ha_change',

  r1_water_whc_increase_10y_uplift_potential_total_pct_change = 'r1_water_whc_increase_10y_uplift_potential_total_pct_change',
  r1_water_whc_increase_10y_uplift_potential_per_ha_pct_change = 'r1_water_whc_increase_10y_uplift_potential_per_ha_pct_change',

  water_fc_total_10y_avg_uplift = 'water_fc_total_10y_avg_uplift',
  water_fc_per_ha_10y_avg_uplift = 'water_fc_per_ha_10y_avg_uplift',

  water_fc_increase_20y_uplift_potential_total_change = 'water_fc_increase_20y_uplift_potential_total_change',
  water_fc_increase_20y_uplift_potential_per_ha_change = 'water_fc_increase_20y_uplift_potential_per_ha_change',

  water_fc_increase_20y_uplift_potential_total_pct_change = 'water_fc_increase_20y_uplift_potential_total_pct_change',
  water_fc_increase_20y_uplift_potential_per_ha_pct_change = 'water_fc_increase_20y_uplift_potential_per_ha_pct_change',

  water_fc_total_20y_avg_uplift = 'water_fc_total_20y_avg_uplift',
  water_fc_per_ha_20y_avg_uplift = 'water_fc_per_ha_20y_avg_uplift',

  // --------------------------------------- SOCIAL
  social_life_expectancy_historic_graph = 'social_life_expectancy_historic_graph',

  // --------------------------------------- POPULATION DENSITY
  // current
  population_density = 'population_density',

  // historic
  population_density_timeseries_graph = 'population_density_timeseries_graph',

  // misc
  population_density_benchmark_graph = 'population_density_benchmark_graph',

  // --------------------------------------- NATURE RISK
  combined_climate_risk = 'combined_climate_risk',

  // --------------------------------------- PROTECTED AREAS (IBAT + OSM)´
  // historic
  protected_areas_area = 'protected_areas_area',
  protected_areas_min_distance = 'protected_areas_min_distance',

  // --------------------------------------- THREATED SPECIES
  // historic
  species_presence_aggregated_count = 'species_presence_aggregated_count',
  species_presence_aggregated_count_by_species = 'species_presence_aggregated_count_by_species',

  // --------------------------------------- NDVI
  // current
  vegetation_condition_ndvi = 'vegetation_condition_ndvi',

  // historic
  vegetation_condition_ndvi_historic_graph = 'vegetation_condition_ndvi_historic_graph',
  vegetation_condition_ndvi_previous_1y_uplift = 'vegetation_condition_ndvi_previous_1y_uplift',
  vegetation_condition_ndvi_previous_1y_pct_change = 'vegetation_condition_ndvi_previous_1y_pct_change',

  // misc
  vegetation_condition_ndvi_benchmark_graph = 'vegetation_condition_ndvi_benchmark_graph',

  // --------------------------------------- LAND COVER CHANGE
  // historic
  landcover = 'landcover',
  landcover_by_landscape_type_historic_pct_graph = 'landcover_by_landscape_type_historic_pct_graph',

  // --------------------------------------- HABITAT INTACTNESS
  // current
  habitat_intactness_total = 'habitat_intactness_total',

  threat_breakdown_total = 'threat_breakdown_total',
  threat_breakdown_latest_total = 'threat_breakdown_latest_total',

  threat_areas_pct = 'threat_areas_pct',

  // historic
  habitat_intactness_total_historic_graph = 'habitat_intactness_total_historic_graph',
  habitat_intactness_baseline_total = 'habitat_intactness_baseline_total',
  habitat_intactness_total_previous_5y_pct_change = 'habitat_intactness_total_previous_5y_pct_change',

  threat_breakdown_total_historic_graph = 'threat_breakdown_total_historic_graph',
  threat_breakdown_baseline_total = 'threat_breakdown_baseline_total',
  threat_breakdown_total_previous_5y_pct_change = 'threat_breakdown_total_previous_5y_pct_change',

  threat_areas_historic_graph = 'threat_areas_historic_graph',
  threat_areas_pct_previous_5y_pct_change = 'threat_areas_pct_previous_5y_pct_change',
  threat_breakdown_total_previous_5y_change = 'threat_breakdown_total_previous_5y_change',

  // misc
  habitat_intactness_total_benchmark = 'habitat_intactness_total_benchmark',
  habitat_intactness_geojson_urls = 'habitat_intactness_geojson_urls',

  // --------------------------------------- CLEANWAVE (customer facts)
  // misc
  marine_shoot_density = 'marine_shoot_density',
  marine_shoot_density_min = 'marine_shoot_density_min',
  marine_shoot_density_max = 'marine_shoot_density_max',
  marine_seagrass_productivity = 'marine_seagrass_productivity',
  marine_seagrass_productivity_min = 'marine_seagrass_productivity_min',
  marine_seagrass_productivity_max = 'marine_seagrass_productivity_max',
  marine_nursery_habitat = 'marine_nursery_habitat',
  marine_nursery_habitat_min = 'marine_nursery_habitat_min',
  marine_nursery_habitat_max = 'marine_nursery_habitat_max',
  marine_biomass = 'marine_biomass',
  marine_biomass_min = 'marine_biomass_min',
  marine_biomass_max = 'marine_biomass_max',
  marine_diversity = 'marine_diversity',
  marine_diversity_min = 'marine_diversity_min',
  marine_diversity_max = 'marine_diversity_max',
  marine_seaweed_meadows_benchmark_graph = 'marine_seaweed_meadows_benchmark_graph',
  marine_seaweed_meadows_benchmark_text = 'marine_seaweed_meadows_benchmark_text',
  marine_biodiversity_uplift = 'marine_biodiversity_uplift',
  marine_survival_rate_1y = 'marine_survival_rate_1y',
  marine_project_progress = 'marine_project_progress',
}

export enum DOMAIN_FACT_TYPES {
  carbon_combined_per_ha_benchmark = 'carbon_combined_per_ha_benchmark',
  carbon_combined_per_ha = 'carbon_combined_per_ha',

  water_combined_benchmark_per_ha = 'water_combined_benchmark_per_ha',
  water_combined_per_ha = 'water_combined_per_ha',

  biodiversity_combined_benchmark_per_ha = 'biodiversity_combined_benchmark_per_ha',
  biodiversity_combined_per_ha = 'biodiversity_combined_per_ha',

  soil_combined_benchmark_per_ha = 'soil_combined_benchmark_per_ha',
  soil_combined_per_ha = 'soil_combined_per_ha',

  social_combined_per_ha = 'social_combined_per_ha',
}

export enum MAP_LAYER_FACTS {
  annual_surface_air_temperature = 'annual_surface_air_temperature',
  annual_precipitation = 'annual_precipitation',
  ocs_0_30cm_mean = 'ocs_0_30cm_mean',
  sand_0_5cm_mean = 'sand_0_5cm_mean',
  cec_0_5cm_mean = 'cec_0_5cm_mean',
  nitrogen_0_5cm_mean = 'nitrogen_0_5cm_mean',
  gbif_species_occurrence = 'gbif_species_occurrence',
  unknown = 'unknown',
  osm_protected_areas = 'osm_protected_areas',
  iucn_protected_areas = 'iucn_protected_areas',
  species_presence_occurrence_location_geojson = 'species_presence_occurrence_location_geojson',
  esa_worldcover = 'esa_worldcover',
  dw_lulc = 'dw_lulc',
  combined_osm_lulc = 'combined_osm_lulc',
  habitat_intactness_raster_urls = 'habitat_intactness_raster_urls',
  ecosystem_integrity_index_map_url = 'ecosystem_integrity_index_map_url',
  combined_ibat_lulc_urls = 'combined_ibat_lulc_urls',
  siemens_protected_areas = 'siemens_protected_areas', // TODO: BIG HACK - MVP-7252 - remove once layer is applicable to all organizations
  indicative_lands = 'indicative_lands',
  indigenous_lands = 'indigenous_lands',
  population_density = 'population_density',
  esa_above_ground_carbon_map_url = 'esa_above_ground_carbon_map_url',
  deforestation_map_url = 'deforestation_map_url',
  marine_habitat_map_url = 'marine_habitat_map_url', // manual fact for cleanwave
  marine_operations_map_url = 'marine_operations_map_url', // manual fact for cleanwave
}

export enum CLIMATE_RISK_FACT_TYPES {
  climate_risk_temperature_air_change = 'climate_risk_temperature_air_change',
  // climate_risk_temperature_freshwater_change = 'climate_risk_temperature_freshwater_change',
  // climate_risk_temperature_marine_water_change = 'climate_risk_temperature_marine_water_change',
  climate_risk_heat_stress = 'climate_risk_heat_stress',
  // climate_risk_temperature_variability = 'climate_risk_temperature_variability',
  // climate_risk_permafrost_thawing = 'climate_risk_permafrost_thawing', // do not show - request from Sales
  // climate_risk_heat_wave = 'climate_risk_heat_wave',
  // climate_risk_cold_spell_frost = 'climate_risk_cold_spell_frost',
  climate_risk_wildfire = 'climate_risk_wildfire',
  // climate_risk_wind_patterns_change = 'climate_risk_wind_patterns_change',
  // climate_risk_tropical_cyclone = 'climate_risk_tropical_cyclone',
  climate_risk_storm_wind = 'climate_risk_storm_wind',
  // climate_risk_storm_blizzard = 'climate_risk_storm_blizzard',
  // climate_risk_storm_dust_sandstorm = 'climate_risk_storm_dust_sandstorm',
  // climate_risk_storm_tornado = 'climate_risk_storm_tornado',
  // climate_risk_precipitation_patterns_change = 'climate_risk_precipitation_patterns_change',
  // climate_risk_precipitation_variability = 'climate_risk_precipitation_variability',
  // climate_risk_ocean_acidification = 'climate_risk_ocean_acidification',
  // climate_risk_saline_intrusion = 'climate_risk_saline_intrusion',
  // climate_risk_sea_level_rise = 'climate_risk_sea_level_rise',
  // climate_risk_water_stress = 'climate_risk_water_stress',
  climate_risk_drought = 'climate_risk_drought',
  climate_risk_heavy_precipitation = 'climate_risk_heavy_precipitation',
  // climate_risk_heavy_precipitation_types = 'climate_risk_heavy_precipitation_types',
  climate_risk_coastal_flood = 'climate_risk_coastal_flood',
  climate_risk_fluvial_flood = 'climate_risk_fluvial_flood',
  // climate_risk_pluvial_groundwater_flood = 'climate_risk_pluvial_groundwater_flood',
  // climate_risk_glacial_lake_outburst = 'climate_risk_glacial_lake_outburst',
  // climate_risk_coastal_erosion = 'climate_risk_coastal_erosion',
  // climate_risk_soil_degradation = 'climate_risk_soil_degradation',
  // climate_risk_soil_erosion = 'climate_risk_soil_erosion',
  // climate_risk_solifluction = 'climate_risk_solifluction',
  // climate_risk_avalanche = 'climate_risk_avalanche',
  // climate_risk_landslide = 'climate_risk_landslide',
  // climate_risk_subsidence = 'climate_risk_subsidence',
}

export const REPORTING_FACT_BENCHMARKS = [
  R1FactType.permanent_soil_carbon_per_ha_benchmark,
  R1FactType.permanent_soil_carbon_total_benchmark,
  R1FactType.water_fc_per_ha_benchmark,
  R1FactType.water_fc_total_benchmark,
];

export const POTENTIAL_FACT_TYPES = [
  R1FactType.r1_carbon_bg_1year_uplift_potential_total_change,
  R1FactType.r1_carbon_bg_1year_uplift_potential_per_ha_change,
  R1FactType.permanent_soil_carbon_5y_uplift_potential_total_change,
  R1FactType.permanent_soil_carbon_5y_uplift_potential_per_ha_change,
  R1FactType.r1_carbon_bg_10year_uplift_potential_total_change,
  R1FactType.r1_carbon_bg_10year_uplift_potential_per_ha_change,
  R1FactType.permanent_soil_carbon_20y_uplift_potential_total_change,
  R1FactType.permanent_soil_carbon_20y_uplift_potential_per_ha_change,

  R1FactType.r1_water_whc_increase_1y_uplift_potential_total_change,
  R1FactType.r1_water_whc_increase_1y_uplift_potential_per_ha_change,
  R1FactType.r1_water_whc_increase_10y_uplift_potential_total_change,
  R1FactType.r1_water_whc_increase_10y_uplift_potential_per_ha_change,
];

export const SIGNED_FACT_TYPES = [
  R1FactType.r1_biodiversity_buffer_zone_pct_previous_1y_uplift_change,

  R1FactType.above_ground_carbon_total_previous_1y_uplift,
  R1FactType.above_ground_carbon_per_ha_previous_1y_uplift,
  R1FactType.above_ground_carbon_total_previous_1y_pct_change,
  R1FactType.above_ground_carbon_per_ha_previous_1y_pct_change,

  R1FactType.r1_carbon_bg_previous_1y_uplift_total,
  R1FactType.r1_carbon_bg_previous_1y_uplift_per_ha,
  R1FactType.r1_carbon_bg_previous_1y_uplift_total_pct_change,
  R1FactType.r1_carbon_bg_previous_1y_uplift_per_ha_pct_change,
  R1FactType.permanent_soil_carbon_total_previous_5y_avg_uplift,
  R1FactType.permanent_soil_carbon_per_ha_previous_5y_avg_uplift,
  R1FactType.r1_carbon_bg_1year_uplift_potential_total_change,
  R1FactType.r1_carbon_bg_1year_uplift_potential_per_ha_change,
  R1FactType.r1_carbon_bg_1year_uplift_potential_total_pct_change,
  R1FactType.r1_carbon_bg_1year_uplift_potential_per_ha_pct_change,
  R1FactType.permanent_soil_carbon_5y_uplift_potential_total_change,
  R1FactType.permanent_soil_carbon_5y_uplift_potential_per_ha_change,
  R1FactType.permanent_soil_carbon_5y_uplift_potential_total_pct_change,
  R1FactType.permanent_soil_carbon_5y_uplift_potential_per_ha_pct_change,
  R1FactType.permanent_soil_carbon_total_5y_avg_uplift,
  R1FactType.permanent_soil_carbon_per_ha_5y_avg_uplift,
  R1FactType.r1_carbon_bg_10year_uplift_potential_total_change,
  R1FactType.r1_carbon_bg_10year_uplift_potential_per_ha_change,
  R1FactType.r1_carbon_bg_10year_uplift_potential_total_pct_change,
  R1FactType.r1_carbon_bg_10year_uplift_potential_per_ha_pct_change,
  R1FactType.permanent_soil_carbon_total_10y_avg_uplift,
  R1FactType.permanent_soil_carbon_per_ha_10y_avg_uplift,
  R1FactType.permanent_soil_carbon_20y_uplift_potential_total_change,
  R1FactType.permanent_soil_carbon_20y_uplift_potential_per_ha_change,
  R1FactType.permanent_soil_carbon_20y_uplift_potential_total_pct_change,
  R1FactType.permanent_soil_carbon_20y_uplift_potential_per_ha_pct_change,
  R1FactType.permanent_soil_carbon_total_20y_avg_uplift,
  R1FactType.permanent_soil_carbon_per_ha_20y_avg_uplift,

  R1FactType.r1_soil_moisture_trend_change,
  R1FactType.r1_precipitation_trend_change,
  R1FactType.r1_whc_previous_1y_uplift_total,
  R1FactType.r1_whc_previous_1y_uplift_per_ha,
  R1FactType.water_fc_total_previous_5y_avg_uplift,
  R1FactType.water_fc_per_ha_previous_5y_avg_uplift,
  R1FactType.r1_water_whc_increase_previous_1y_uplift_total_pct_change,
  R1FactType.r1_water_whc_increase_previous_1y_uplift_per_ha_pct_change,
  R1FactType.r1_water_whc_increase_1y_uplift_potential_total_change,
  R1FactType.r1_water_whc_increase_1y_uplift_potential_per_ha_change,
  R1FactType.r1_water_whc_increase_1y_uplift_potential_total_pct_change,
  R1FactType.r1_water_whc_increase_1y_uplift_potential_per_ha_pct_change,
  R1FactType.water_fc_increase_5y_uplift_potential_total_change,
  R1FactType.water_fc_increase_5y_uplift_potential_per_ha_change,
  R1FactType.water_fc_increase_5y_uplift_potential_total_pct_change,
  R1FactType.water_fc_increase_5y_uplift_potential_per_ha_pct_change,
  R1FactType.water_fc_total_5y_avg_uplift,
  R1FactType.water_fc_per_ha_5y_avg_uplift,
  R1FactType.r1_water_whc_increase_10y_uplift_potential_total_change,
  R1FactType.r1_water_whc_increase_10y_uplift_potential_per_ha_change,
  R1FactType.r1_water_whc_increase_10y_uplift_potential_total_pct_change,
  R1FactType.r1_water_whc_increase_10y_uplift_potential_per_ha_pct_change,
  R1FactType.water_fc_total_10y_avg_uplift,
  R1FactType.water_fc_per_ha_10y_avg_uplift,
  R1FactType.water_fc_increase_20y_uplift_potential_total_change,
  R1FactType.water_fc_increase_20y_uplift_potential_per_ha_change,
  R1FactType.water_fc_increase_20y_uplift_potential_total_pct_change,
  R1FactType.water_fc_increase_20y_uplift_potential_per_ha_pct_change,
  R1FactType.water_fc_total_20y_avg_uplift,
  R1FactType.water_fc_per_ha_20y_avg_uplift,

  R1FactType.water_fc_per_ha_previous_5y_pct_change,
  R1FactType.above_ground_carbon_per_ha_previous_5y_pct_change,
  R1FactType.biodiversity_buffer_zone_pct_previous_5y_pct_change,
  R1FactType.deforestation_previous_5y_pct_change,
  R1FactType.permanent_soil_carbon_per_ha_previous_5y_pct_change,

  R1FactType.social_life_expectancy,
  R1FactType.social_life_expectancy_previous_1y_pct_change,
  R1FactType.biodiversity_buffer_zone_pct_previous_1y_pct_change,
  R1FactType.deforestation_previous_1y_pct_change,
  R1FactType.above_ground_carbon_per_ha_previous_1y_pct_change,
  R1FactType.water_fc_per_ha_previous_1y_pct_change,
  R1FactType.soil_moisture_smooth_timeseries_per_ha_previous_1y_pct_change,
];

export const LANDSCAPE_VIEW_FACTS: readonly IndicatorFactType[] = [
  // Protected areas (IBAT + OSM)
  R1FactType.protected_areas_area,
  R1FactType.protected_areas_min_distance,

  // Threatened species
  R1FactType.species_presence_aggregated_count,
  R1FactType.species_presence_aggregated_count_by_species,

  // Landcover change
  R1FactType.landcover_by_landscape_type_historic_pct_graph,

  // Maps
  MAP_LAYER_FACTS.species_presence_occurrence_location_geojson,
  MAP_LAYER_FACTS.osm_protected_areas,
  MAP_LAYER_FACTS.iucn_protected_areas,
  MAP_LAYER_FACTS.esa_worldcover,
  MAP_LAYER_FACTS.combined_ibat_lulc_urls,
  // TODO: BIG HACK - MVP-7252 - remove once layer is applicable to all organizations
  MAP_LAYER_FACTS.siemens_protected_areas,
] as const;

export enum FactValidationStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  UNVALIDATED = 'UNVALIDATED',
  VALIDATED = 'VALIDATED',
  MODEL_LIMITATION = 'MODEL_LIMITATION',
}

export enum BenchmarkType {
  unchanged = 'unchanged',
  very_low = 'very_low',
  low = 'low',
  moderate = 'moderate',
  high = 'high',
  stable = 'stable',
  alerted = 'alerted',
}

export enum LandUse {
  cultivated = 'cultivated',
  paddy = 'paddy',
  perennial = 'perennial',
  set_aside = 'set_aside',
  native = 'native',
}

export enum CarbonInput {
  high_c_input_without_manure = 'high_c_input_without_manure',
  high_c_input_with_manure = 'high_c_input_with_manure',
  medium_c_input = 'medium_c_input',
  low_c_input = 'low_c_input',
}

export enum Tillage {
  full = 'full',
  reduced = 'reduced',
  no_till = 'no_till',
}

export enum Scenario {
  baseline = 'baseline',
  best = 'best',
  moderate = 'moderate',
  worst = 'worst',
}

export enum ClimateRiskRating {
  not_relevant = 'not_relevant',
  very_low = 'very_low',
  low = 'low',
  medium = 'medium',
  high = 'high',
  very_high = 'very_high',
}

export enum LandscapeType {
  tree_cover = 'tree_cover',
  built_up = 'built_up',
  cropland = 'cropland',
  grassland = 'grassland',
  bareground = 'bareground',
  herbaceous_wetland = 'herbaceous_wetland',
  shrubland = 'shrubland',
  permanent_water_bodies = 'permanent_water_bodies',
}

export enum ClimateRiskRatingOrder {
  not_relevant = 0,
  very_low = 1,
  low = 2,
  medium = 3,
  high = 4,
  very_high = 5,
}

export enum ThreatType {
  no_threat_area = 'no_threat_area',
  cropland = 'cropland',
  deforestation = 'deforestation',
  builtup = 'builtup',
  roads = 'roads',
}

export const THREAT_TYPES = Object.values(ThreatType);
export const HABITAT_INTACTNESS_KEY = 'habitat_intactness';

export type HabitatIntactnessAndThreats = ThreatType | typeof HABITAT_INTACTNESS_KEY;

export type LayerMetadata = {
  asset_id: string;
  provenance: {
    source_dataset: string;
    source_year: number;
  };
  storage_uri: string;
  map_url: string;
};
export type RasterLayerYear = `20${number}`;

export type LayerFactValue = Partial<Record<HabitatIntactnessAndThreats, Record<RasterLayerYear, LayerMetadata>>>;
export type MapRastersFact = PlotReportFactElement<LayerFactValue>;

export const ClimateRiskRatingsByIndex = ['not_relevant', 'very_low', 'low', 'medium', 'high', 'very_high'];

export enum ConservationBenchmark {
  pristine = 'pristine',
  good = 'good',
  fair = 'fair',
  poor = 'poor',
  critical = 'critical',
}

export enum DeforestationCategory {
  forest_loss = 'forest_loss',
  no_loss_detected = 'no_loss_detected',
}

export enum SpeciesEnum {
  posidonia = 'posidonia',
}

export enum MarineFunctionalGroupEnum {
  macroinvertebrate = 'macroinvertebrate',
  fish = 'fish',
}

export enum PopulationDensityBenchmark {
  urban_center = 'urban_center',
  urban_cluster = 'urban_cluster',
  rural = 'rural',
}

export enum EcosystemType {
  marine = 'marine',
  terrestrial = 'terrestrial',
}

export enum PlotReportFactLabelNameEnum {
  benchmark = 'benchmark',
  benchmark_conservation = 'benchmark_conservation',
  benchmark_population_density = 'benchmark_population_density',
  deforestation = 'deforestation',
  uncertainty = 'uncertainty',
  carbon_input = 'carbon_input',
  tillage = 'tillage',
  land_use = 'land_use',
  value_class = 'value_class',
  scenario = 'scenario',
  landscape_radius = 'landscape_radius',
  landscape_radius_m = 'landscape_radius_m', // use only for querying facts data
  protection_category = 'protection_category',
  kingdom = 'kingdom',
  iucn_redlist_category = 'iucn_redlist_category',
  species = 'species',
  landscape_type = 'landscape_type',
  threat_type = 'threat_type',
  functional_group = 'functional_group',
  ecosystem_type = 'ecosystem_type',
}

export enum ValueClass {
  interpolated = 'interpolated',
  valid_estimate = 'valid_estimate',
  interpolation_not_possible = 'interpolation_not_possible',
}

export type PlotReportFactLabelFilter = Partial<Record<PlotReportFactLabelNameEnum, string>>;

export type PlotReportFactLabel<T = number | string | null | unknown> = {
  name: PlotReportFactLabelNameEnum;
  value: T;
};

export type PlotReportFactElement<T = number | string | null | unknown> = {
  name: IndicatorFactType;
  value: T;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadata?: Record<string, any>;
  upper_confidence_limit: T;
  lower_confidence_limit: T;
  unit: UnitEnum;
  status: FactValidationStatus;
  measured_at: string | null;
  previous_1y_measured_at: string | null;
  labels: PlotReportFactLabel[];
};
